export const ANCHOR_OPTIONS = [
  { value: "doors", label: "Doors" },
  { value: "show_start", label: "Show start" },
  { value: "show_end", label: "Show end" },
];

export const offsetLabel = (minutes) => {
  if (minutes === 0) return "exactly";
  return `${minutes > 0 ? "+" : "−"}${Math.abs(minutes)} min`;
};

export const OFFSET_OPTIONS = Array.from({ length: 33 }, (_, index) => {
  const minutes = -240 + index * 15;
  return { value: String(minutes), label: offsetLabel(minutes) };
});

export const offsetOptionsFor = (minutes) =>
  OFFSET_OPTIONS.some((option) => option.value === String(minutes))
    ? OFFSET_OPTIONS
    : [
        ...OFFSET_OPTIONS,
        { value: String(minutes), label: offsetLabel(minutes) },
      ].sort((a, b) => Number(a.value) - Number(b.value));

// Minutes after the show day's midnight, as "7p" or "11:30p".
export const clockFromMinutes = (total) => {
  const minutes = ((total % 1440) + 1440) % 1440;
  const hour = Math.floor(minutes / 60);
  const minute = minutes % 60;
  const suffix = hour >= 12 ? "p" : "a";
  return `${hour % 12 || 12}${minute ? `:${String(minute).padStart(2, "0")}` : ""}${suffix}`;
};

export const roundedHours = (hours) =>
  (Math.round(hours * 10) / 10).toLocaleString("en-US");

export const lineTimes = (line, sample) => {
  const start = sample[line.start_anchor];
  const end = sample[line.end_anchor];
  if (
    start === null ||
    start === undefined ||
    end === null ||
    end === undefined
  )
    return null;
  return {
    start: start + Number(line.start_offset_minutes),
    end: end + Number(line.end_offset_minutes),
  };
};

// The prototype's per-show estimate: each line's hours less a 30 minute break past 6 hours, at the position's rate.
export const perShowCost = (lines, sample, rates) =>
  lines.reduce((sum, line) => {
    const times = lineTimes(line, sample);
    const rate = Number(rates[line.staff_position_id] || 0);
    if (!times || !rate) return sum;
    const hours = (times.end - times.start) / 60;
    return sum + line.headcount * (hours - (hours > 6 ? 0.5 : 0)) * rate;
  }, 0);

export const wholeDollars = (amount) =>
  `$${Math.round(Number(amount)).toLocaleString("en-US")}`;
